export const findAndReplaceLinksInText = (text: string): string => {
	const pattern =
		/\b((https?:\/\/)?(www\.)?[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}(\/[^\s]*)?)\b/gi;
	return text.replace(pattern, (match, p1) => {
		const url = p1.startsWith('http') ? p1 : `https://${p1}`;
		return `<a href="${url}" target="_blank" rel="noopener noreferrer">${match}</a>`;
	});
};
